module.exports = __webpack_public_path__ + "icon-tw@2x.png?d9e39749280785c6893a7e5949d65e95";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-tw@2x.png
// module id = 209
// module chunks = 0